import { jsx as m } from "react/jsx-runtime";
import { createPortal as a } from "react-dom";
import n from "classnames";
const d = 47, c = ({
  id: r,
  show: i,
  controlRef: t,
  children: s,
  className: u
}) => {
  const p = (t == null ? void 0 : t.current) || document.getElementById("tooltip-root");
  if (!p || !(t != null && t.current) || !i)
    return null;
  const e = t.current.getBoundingClientRect();
  return a(
    /* @__PURE__ */ m(
      "div",
      {
        id: `input_tooltip_${r}`,
        className: n("input-tooltip", i && "show", u),
        style: { top: -d + "px", left: e.width / 2 + "px" },
        children: s
      }
    ),
    p
  );
};
export {
  c as default
};
